<td class="mdl-data-table__cell--non-numeric">Unsynchronized Calculator Result GroupIds</td>
<td class="mdl-data-table__cell--non-numeric">
    Shows number of Calculation Results which have GroupId field value different from GroupId field of related Property
    Record
</td>
<td>{{instanceMonitoringData?.unsynchronizedCRGroupIdsCount}}</td>
<td>
    <mat-icon *ngIf="!needFix" style="color: green;">
        check
    </mat-icon>
    <mat-icon *ngIf="needFix" style="color: red;">
        close
    </mat-icon>
</td>
<td>
    <button mat-icon-button class="process-actions-button" (click)="fix()" [disabled]="!needFix">
        <mat-icon matTooltip="Fix">
            handyman
        </mat-icon>
    </button>
    <app-process-small-spinner [isVisible]="state.isWaitingActionFinish"></app-process-small-spinner>
</td>
